import React from "react";
import ResetPassword from "./ResetPassword";

const ResetPasswordWithQuery = props => (
  <ResetPassword title={"ResetPassword"} {...props} />
);

export default ResetPasswordWithQuery;
